import moment from 'moment';

export function timestampToUTC(timestamp) {
  const date = new Date(timestamp * 1000);
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}
export function timestampFormat(timestamp) {
  const date = new Date(timestamp * 1000);
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  );
}

// Check Moment.js patterns in http://momentjs.com/docs/#/displaying/
export function formatDateTime(date, pattern) {
  return moment(date).format(pattern);
}

export function durationToHHMM(durationInSeconds) {
  const hours = Math.floor(durationInSeconds / 3600);
  const min = Math.floor((durationInSeconds - (hours * 3600)) / 60);

  return {
    hours,
    min
  };
}
